"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductImage = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _defaultImage = _interopRequireDefault(require("./default-image"));
var _excluded = ["alt", "src", "isAltReal", "border", "dataTestId", "sources", "lazy", "fetchPriority"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var propTypes = {
  alt: _propTypes["default"].string.isRequired,
  src: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  isAltReal: _propTypes["default"].bool,
  lazy: _propTypes["default"].bool,
  border: _propTypes["default"].string,
  fetchPriority: _propTypes["default"].oneOf(['low', 'auto', 'high']),
  sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    media: _propTypes["default"].string,
    srcsetList: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      template: _propTypes["default"].string,
      scale: _propTypes["default"].string
    }))
  }))
};
var defaultProps = {
  dataTestId: null,
  isAltReal: false,
  src: '',
  lazy: false,
  border: null,
  sources: [],
  fetchPriority: null
};
var StyledPicture = _styledComponents["default"].picture.withConfig({
  displayName: "product-image__StyledPicture",
  componentId: "sc-1oh70ge-0"
})(["position:relative;width:100%;padding-top:133.33%;"]);
var isExist = function isExist(arr) {
  return arr && Array.isArray(arr) && arr.length > 0;
};
var hasTemplate = function hasTemplate(_ref) {
  var template = _ref.template;
  return template && typeof template === 'string';
};
var isMultiSrc = function isMultiSrc(srcs) {
  return srcs && srcs.length && srcs.every(hasTemplate);
};
var defaultBorderStyle = 'var(--border-width-xs) solid var(--color-global-grey300)';
var ProductImage = exports.ProductImage = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var alt = _ref2.alt,
    src = _ref2.src,
    isAltReal = _ref2.isAltReal,
    border = _ref2.border,
    dataTestId = _ref2.dataTestId,
    sources = _ref2.sources,
    lazy = _ref2.lazy,
    fetchPriority = _ref2.fetchPriority,
    props = _objectWithoutProperties(_ref2, _excluded);
  var borderStyle = border || defaultBorderStyle;
  var styles = (0, _react.useMemo)(function () {
    return {
      display: 'block',
      width: '100%',
      objectFit: 'cover',
      boxSizing: 'border-box',
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      border: borderStyle
    };
  }, [borderStyle]);
  var imgSrc = (0, _react.useMemo)(function () {
    return src.includes('?') ? "".concat(src, "&") : "".concat(src, "?");
  }, [src]);
  var buildImageSrc = (0, _react.useCallback)(function (params) {
    if (!(params !== null && params !== void 0 && params.length)) {
      return src;
    }
    return "".concat(imgSrc).concat(params.join('&'));
  }, [src, imgSrc]);
  var srcSets = (0, _react.useMemo)(function () {
    var baseParams = ['fmt=auto'];
    if (!isExist(sources)) return [{
      srcSet: buildImageSrc(baseParams)
    }];
    return sources.map(function (_ref3) {
      var media = _ref3.media,
        srcsetList = _ref3.srcsetList;
      if (!isMultiSrc(srcsetList)) {
        return buildImageSrc(baseParams);
      }
      var params = [].concat(baseParams);
      return {
        media: media,
        srcSet: srcsetList.map(function (_ref4) {
          var template = _ref4.template,
            scale = _ref4.scale;
          var paramsWithTpl = ["$".concat(template, "$")].concat(_toConsumableArray(params));
          var scaleStr = scale ? " ".concat(scale) : '';
          return "".concat(buildImageSrc(paramsWithTpl)).concat(scaleStr);
        }).join(', ')
      };
    });
  }, [buildImageSrc, sources]);
  if (!src) {
    return /*#__PURE__*/_react["default"].createElement(_defaultImage["default"], _extends({
      alt: alt,
      isAltReal: isAltReal
    }, props));
  }
  return /*#__PURE__*/_react["default"].createElement(StyledPicture, _extends({
    className: "fuse-product-image"
  }, props), srcSets.map(function (attrs, idx) {
    return /*#__PURE__*/_react["default"].createElement("source", _extends({
      key: attrs.media || idx
    }, attrs));
  }), /*#__PURE__*/_react["default"].createElement("img", _extends({
    src: "".concat(imgSrc, "fmt=auto"),
    alt: alt,
    ref: ref,
    className: "fuse-product-image__img",
    loading: lazy ? 'lazy' : 'eager',
    fetchpriority: fetchPriority || 'auto',
    "data-testid": dataTestId || 'fuse-product-image',
    "aria-hidden": isAltReal ? undefined : 'true',
    style: styles
  }, props)));
});
ProductImage.propTypes = propTypes;
ProductImage.defaultProps = defaultProps;
ProductImage.displayName = 'ProductImage';
var _default = exports["default"] = ProductImage;